import React from 'react';

import { DashboardLayoutComponent } from 'design/dashboardLayout';
import { PartnerDashboardHeader } from 'containers/PartnerDashboard/PartnerDashboardHeader';
import { PartnerDashboardFooter } from 'containers/PartnerDashboard/PartnerDashboardFooter';
import { PartnerDashboardBody } from 'containers/PartnerDashboard/PartnerDashboardBody';
import {
  PartnerAccountManager,
  PartnerAccountManagerScreen,
} from 'containers/PartnerAccountManager/PartnerAccountManager';
import { useRouterProcess } from 'hooks/useRouterProcess';
import { AsyncBoundaryComponent } from 'utils/asyncBoundary/asyncBoundaryComponents';

export const PartnerDashboard = () => {
  useRouterProcess();

  const [
    profileManagerScreen,
    setProfileManagerScreen,
  ] = React.useState<null | PartnerAccountManagerScreen>(null);

  const openProfileSummaryManager = React.useCallback(() => {
    setProfileManagerScreen('SUMMARY');
  }, []);

  const closeProfileManager = React.useCallback(() => {
    setProfileManagerScreen(null);
  }, []);

  const openProfileFinancesManager = React.useCallback(() => {
    setProfileManagerScreen('FINANCES');
  }, []);

  return (
    <>
      <DashboardLayoutComponent
        header={
          <PartnerDashboardHeader
            onManageProfile={openProfileSummaryManager}
            onManageFinances={openProfileFinancesManager}
          />
        }
        body={
          <AsyncBoundaryComponent fallback={null}>
            <PartnerDashboardBody />
          </AsyncBoundaryComponent>
        }
        footer={<PartnerDashboardFooter />}
      />
      {profileManagerScreen && (
        <PartnerAccountManager
          initialScreen={profileManagerScreen}
          onClose={closeProfileManager}
        />
      )}
    </>
  );
};
